<script lang="tsx">
  import { defineComponent, PropType } from 'vue'
  import { BeerStyleObj } from '@xhs/yam-beer/core'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'

  export type BeerBadgeVariant = 'primary' | 'success' | 'danger' | 'warn'

  export default defineComponent({
    name: 'BeerBadge',
    props: {
      /**
       * @ignore
       * 容器 bs style
       * @see style
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * 上标内容
       *
       * 与 AntD 的 count / text 类似
       */
      content: {
        type: [String, Number] as PropType<number | string>,
        default: null,
      },
      /**
       * 上标设置为小红点，会覆盖 content 内容
       */
      dot: {
        type: Boolean,
        default: false,
      },
      /**
       * 当内容是 Number 的时候，设置最大的数字
       *
       * @version 4.1.0
       */
      overflowCount: {
        type: Number,
        default: 99,
      },
      /**
       * 使用 overflowCount
       * @deprecated 4.1.0
       */
      max: {
        type: Number,
        default: 99,
      },
      /**
       * 是否隐藏上标
       * @type {true|false}
       */
      hidden: {
        type: Boolean,
        default: false,
      },
      /**
       * 意图颜色，用来呈现上标的意图提示
       *
       * 部分实现了antD 的 color 和 status的功能
       * @type {primary|success|danger|warn}
       * @version 4.1.0
       */
      modifier: {
        type: String as PropType<BeerBadgeVariant>,
        default: 'danger',
      },
      /**
       * 鼠标悬浮在圈圈上显示的提示，HTML 原生功能
       */
      title: {
        type: String,
        required: false,
      },
      /**
       * 使用modifier
       * @deprecated 4.1.0
       */
      variant: {
        type: String as PropType<BeerBadgeVariant>,
        default: 'danger',
      },
      /**
       * @ignore
       * 上标的 inline 样式
       * @see style
       */
      supbs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
    },
    setup(props, { slots, attrs }) {
      return () => {
        const hasDefault = !!slots.default
        const wrapperBs: BeerStyleObj = {
          ...(hasDefault ? {
            position: 'relative',
            display: 'inline-block',
          } : {
            display: 'inline-flex',
            alignItems: 'center',
          }),
          ...props.bs,
          '.supVbs': {
            ...(hasDefault ? {
              position: 'absolute',
              top: 0,
              right: 0,
              transform: 'translateY(-50%) translateX(50%)',
            } : {}),
            ...(props.dot ? {
              size: 6,
            } : {
              fontSize: 12,
              height: 18,
              lineHeight: 18,
              py: 0,
              px: 6,
              textAlign: 'center',
              whiteSpace: 'nowrap',
              border: '1px solid #fff',
            }),
            borderRadius: 10,
            color: 'white',
            display: 'inline-block',
            bg: props.modifier,
            ...props.supbs,
          },
        }

        const contentIsNumber = typeof props.content === 'number'
        let badgeText = props.content
        const max = props.overflowCount || props.max
        if (contentIsNumber && max) {
          if (props.content > max) {
            badgeText = `${max}+`
          }
        }
        return (
          <NewBsBox class="badge-container" bs={wrapperBs} {...attrs}>
            {slots.default ? slots.default() : null}
            {!props.hidden && (
              /** @slot count 自定义的上标内容 */
              <sup class="supVbs badge-sup" title={props.title}>{slots.count ? slots.count() : badgeText}</sup>
            )}
          </NewBsBox>
        )
      }
    },
  })
</script>
